import React, { useCallback } from 'react';
import { BiData, BiContextProvidedValue } from '@wix/da-bi/pkg/events';
import { useTranslation } from 'react-i18next';
import { ListItemLink, ListItemButton } from '@wix/da-ds/pkg/List/ListItem';
import { URLS, Url } from '@wix/da-url';
import { ResourceType } from '../../../types/resource';
const GoToTierDashboard = ({ deviation, stopPropagation, anchorless })=>{
    var _deviation_tier;
    const { t } = useTranslation();
    const dashboardUrl = `${Url.buildFromPath(URLS.CUSTOMER_DASHBOARD)}?subproductid=${(_deviation_tier = deviation.tier) === null || _deviation_tier === void 0 ? void 0 : _deviation_tier.subproductId}`;
    const openDashboard = useCallback(()=>{
        window.location.href = dashboardUrl;
    }, [
        deviation
    ]);
    if (anchorless) {
        return /*#__PURE__*/ React.createElement(ListItemButton, {
            label: t('deviationview.tierCard.moreActionsMenu.item.goToTierDashboard'),
            onClick: openDashboard,
            fillContainerWidth: true,
            stopPropagation: stopPropagation,
            biData: BiData({
                evid: 2,
                typeid: ResourceType.TIER,
                itemid: deviation.tier.tierId,
                sectionname: BiContextProvidedValue,
                click_info: 'tier_order_history'
            })
        });
    }
    return /*#__PURE__*/ React.createElement(ListItemLink, {
        label: t('deviationview.tierCard.moreActionsMenu.item.goToTierDashboard'),
        href: dashboardUrl,
        stopPropagation: stopPropagation
    });
};
GoToTierDashboard.displayName = 'GoToTierDashboard';
export default GoToTierDashboard;

//# sourceMappingURL=GoToTierDashboard.js.map